module.exports = __webpack_public_path__ + "img/hashed.6f3e28f9.svg";